import axios from './index'
import store from '@/store'
import { cleanParams } from '@/filters'
export const getDataSetByPage = (params) => {
  const currentRole = store.state.currentRole
  const { companyId, teamId } = currentRole
  return axios.get('/welldbCombine/dataset/withSub', {
    params: cleanParams({ ...params, companyId, teamId, field: 'createTime', order: 'desc' })
  })
}
export const getAllData = (params) => {
  return axios.get('/welldbCombine/dataset/withSub', {
    params: cleanParams({ ...params })
  })
}
export const addDataSet = (params) => {
  const user = store.state.userInfo
  const currentRole = store.state.currentRole
  const { companyId, teamId } = currentRole
  return axios.post('/welldbCombine/dataset', {
    moveToQuery: true,
    params: cleanParams({ ...params, 'dataset.companyId': companyId, 'dataset.teamId': teamId, 'dataset.createUserId': user.userId })
  })
}

export const updateDataSet = (params) => {
  const user = store.state.userInfo
  return axios.put('/welldbCombine/dataset', {
    moveToQuery: true,
    params: cleanParams({ ...params, updateUserId: user.userId })
  })
}

export const deleteDataSet = (id) => {
  return axios.delete('/welldbCombine/dataset', {
    params: {
      id
    }
  })
}

export const getDatasetItem = async (params) => {
  const { datasetId, pageNum, pageSize } = params
  const res1 = await axios.get('/welldbCombine/dataset', {
    params: {
      id: datasetId
    }
  })
  const dataset = res1.data.map.data.rows[0]
  if (dataset) {
    const res2 = await axios.get('/welldbCombine/datasetandItem', {
      params: {
        datasetId,
        pageNum,
        pageSize
      }
    })
    const data2 = res2.data.map.data
    const data3 = []
    for (const itemInfo of data2.rows) {
      const res3 = await axios.get('/welldbCombine/item', {
        params: {
          id: itemInfo.itemId
        }
      })
      data3.push(res3.data.map.data.rows[0])
    }
    return {
      data: data3,
      total: data2.total
    }
  } else {
    return Promise.reject(new Error('数据集不存在'))
  }
}
export const getDataset = async (params) => {
  const { datasetId, pageNum, pageSize } = params
  const res1 = await axios.get('/welldbCombine/dataset/withSub', {
    params: {
      id: datasetId
    }
  })
  const dataset = res1.data.map.data.rows[0]
  if (dataset) {
    const res2 = await axios.get('/welldbCombine/datasetandItem', {
      params: {
        datasetId,
        pageNum,
        pageSize
      }
    })
    const data2 = res2.data.map.data
    return {
      total: data2.total
    }
  } else {
    return Promise.reject(new Error('数据集不存在'))
  }
}


export const getDataSetByPages = (params) => {
  const currentRole = store.state.currentRole
  const { companyId, teamId } = currentRole
  return axios.get('/welldbCombine/dataset', {
    params: cleanParams({ ...params, companyId, teamId, field: 'createTime', order: 'desc' })
  })
}


//数据集内数据筛选
export const findItemsByDataset = (data) => {
  return axios.post('/welldbCombine/api/item/findItemsByDataset', {
    ...data
  })
}




//根据筛选数据结果创建新数据集
export const createDatasetFormDataset = (data) => {
  return axios.post('/welldbCombine/api/dataset/createDatasetFormDataset', {
    ...data
  })
}


//根据筛选数据结果添加到指定数据集
export const addItemToDataset = (data) => {
  return axios.post('/welldbCombine/api/dataset/addItemToDataset', {
    ...data
  })
}


